// Couleur d'un expert (ck2020_user.u_color) utilisable sur une carte claire.
//
// 7 experts sur 409 ont u_color = "#ffffff" : leur tracé et leurs marqueurs
// étaient purement invisibles sur la carte. On retombe pour eux sur l'accent du
// projet, faute d'une couleur exploitable.
const FALLBACK_COLOR = "#6067AE";

const expertColor = (color) => {
  if (!color) {
    return FALLBACK_COLOR;
  }

  const value = String(color).trim().toLowerCase();

  if (!value || ["#fff", "#ffffff", "white"].includes(value)) {
    return FALLBACK_COLOR;
  }

  return value;
};

export default expertColor;
